export const formatTimeWithSeconds = (timeString) => {
  if (!timeString) return null;

  if (timeString.split(':').length === 3) return timeString;

  return `${timeString}:00`;
};
